import * as React from 'react'
import {
  LiveChatWidget,
  useWidgetState,
  useWidgetIsReady,
  useWidgetGreeting,
  useWidgetCustomerData
} from '@livechat/widget-react'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MakeAnOffer from '../popups/MakeAnOffer'
import CallKeithPopUp from '../popups/CallKeithPopUp'
import AskAQuestion from '../popups/AskAQuestion'
import { unhideChat, hideChat } from '../../state/popupForms'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import useMediaQuery from '../../hooks/useMediaQuery'
import TailwindScreens from '../../helpers/tailwind'
import {
  CHAT_STATE_LOADING,
  CHAT_STATE_HIDDEN,
  CHAT_STATE_OPEN,
  CHAT_STATE_ANY,
  CHAT_STATE_CLOSED,
} from '../../state/popupForms'
import { TrackUser, TrackEvent, PersonalInfo } from '../../helpers/TrackingHelper'
import { useCookieConsent } from '../../contexts/CookieConsentContext'
import GoogleAds from '../../../utils/GoogleAds'

// noinspection JSValidateTypes
const PopUpsAndChat = () => {
  const { prefs, setPrefs } = useCookieConsent()
  const dispatch = useDispatch()
  const isMd = useMediaQuery(TailwindScreens.md)
  const [showBackdrop, setShowBackdrop] = useState(false)
  const [banners, setBanners] = useState(null)

  const customerData = useWidgetCustomerData()
  const greeting = useWidgetGreeting()
  // const chatData = useWidgetChatData()
  const isWidgetReady = useWidgetIsReady()
  const widgetState = useWidgetState()

  const popupForms = useSelector(state => state.popupForms)
  const group = popupForms.offerSent ? 1 : 3
  const onLiveChatFormSubmitted = data => {
    var full_name = customerData.name
    var email = customerData.email 
    TrackUser(email, PersonalInfo({ ...customerData, name: full_name, full_name }))
    const eventData = {
      ...customerData,
      email: email,
      name: full_name,
      full_name,
      '$email': email,
      '$name': full_name,
      event_type: data.type ,
      event_category: 'Live Chat'
    }
    if (data.type === 'prechat') {
      TrackEvent('live_chat_started', eventData, {
        googleAdsConversion: GoogleAds.Conversions.live_chat_started,
        klaviyoEventName:'Started Live Chat'
      })
    } else if (data.type === 'postchat') {
      TrackEvent('live_chat_postchat_form_submitted', eventData, {
        klaviyoEventName:'Live Chat Postchat Form Submitted'
      })
    } else if (data.type === 'ticket') {
      TrackEvent('live_chat_ticket_submitted', eventData, {
        klaviyoEventName:'Live Chat Postchat Form Submitted'

      })
    } else {
      TrackEvent('live_chat_form_submitted', eventData, {
        klaviyoEventName: 'Live Chat Form Submitted'
      })
    }
  }

  let chatVisibility = 'hidden'
  switch (popupForms.chatState) {
    case CHAT_STATE_LOADING:
    case CHAT_STATE_HIDDEN:
      break
    case CHAT_STATE_CLOSED:
      chatVisibility = 'minimized'
      break
    case CHAT_STATE_ANY:
      //chatVisibility = isMd ? 'minimized' : 'hidden'
      chatVisibility = 'hidden'
      break
    case CHAT_STATE_OPEN:
      chatVisibility = 'maximized'
      break
  }
  if (popupForms.chatStateOverlay === CHAT_STATE_HIDDEN) {
    chatVisibility = 'hidden'
  }

  // This is used for time-based triggered popups
  // React.useEffect(() => {
  //   if (typeof window === 'undefined') return
  //   const keithBanner = window.sessionStorage.getItem('keithBanner')
  //   console.log(keithBanner)
  //
  //   const timeout = setTimeout(() => {
  //     fetch('/api/time')
  //       .then(res => res.json())
  //       .then(data => {
  //         const time = new Date(data.time)
  //         const isSunday = time.getDay() === 0
  //         const is1145OrLater =
  //           (time.getHours() == 11 && time.getMinutes() >= 45) || time.getHours() >= 12
  //         const is5PmOrEarlier = time.getHours() < 17
  //         const isOpen = isSunday && is1145OrLater && is5PmOrEarlier
  //         // console.log('Keith Popup', isOpen)
  //         // console.log({
  //         //   is1145OrLater,
  //         //   is5PmOrEarlier,
  //         //   isOpen,
  //         //   isSunday,
  //         //   h: time.getHours(),
  //         //   m: time.getMinutes(),
  //         // })
  //         // Sunday, from 12pm to 4pm
  //         if (isOpen) {
  //           if (!keithBanner) {
  //             setBanners('keith')
  //           }
  //           dispatch(hideChat())
  //           dispatch(showKeithSideCard(true))
  //           window?.LC_API.hide_chat_window()
  //           window.sessionStorage.setItem('keithBanner', true)
  //         } else {
  //           setBanners(null)
  //           dispatch(showKeithSideCard(false))
  //         }
  //       })
  //       .catch(err => console.error(err))
  //   }, 2000)
  //   return () => {
  //     clearTimeout(timeout)
  //   }
  // }, [])

  React.useEffect(() => {
    if (popupForms.chatStateOverlay !== CHAT_STATE_LOADING) return
    const timeout = setTimeout(() => {
      dispatch(unhideChat())
    }, 5000)
    return () => {
      clearTimeout(timeout)
    }
  }, [popupForms.chatStateOverlay])

  useEffect(() => {
    if (popupForms.showPopup) {
      // setChatVisibility('hidden')
      window.scrollTo(0, 0)
    }
  }, [popupForms.showPopup])

  const handleVisibilityChanged = React.useCallback(({ visibility }) => {
    if (visibility === 'minimized') {
      dispatch(unhideChat())
    }
  }, [])
  React.useEffect(() => {
    // if (isMd) {
    //   return
    // }
    if (popupForms.chatState === CHAT_STATE_OPEN) {
      if(prefs.liveChat === false) {
        if(confirm('Live chat is disabled in your preferences. Customize your cookies to enable Live Chat support. Do you want to enable it now?'))
        { 
          setPrefs({ ...prefs, liveChat: true })
        } else {
          dispatch(unhideChat())
        }
      }
      return
    }
    if (!isWidgetReady) {
      return
    }
    dispatch(hideChat())
    if (typeof window === 'undefined') {
      return
    }
    window?.LC_API.hide_chat_window()
  }, [greeting, isWidgetReady, widgetState, isMd, popupForms.chatState,prefs, setPrefs])

  return (
    <div>
      {showBackdrop ? (
        <button
          onClick={() => setShowBackdrop(false)}
          className="hidden cursor-pointer md:block top-0 left-0 fixed w-screen h-screen bg-gray-500 opacity-50 backdrop-blur-sm"
        />
      ) : null}
      {(popupForms.showPopup || banners) && (
        <Helmet bodyAttributes={{ class: 'overflow-hidden' }} />
      )}
      {popupForms.showPopup && !popupForms.makeAnOffer ? (
        <AskAQuestion product={popupForms.product} category={popupForms?.category || ''} />
      ) : null}
      {popupForms.showPopup && popupForms.makeAnOffer ? (
        <MakeAnOffer product={popupForms.product} category={popupForms?.category || ''} />
      ) : null}
      {banners && banners === 'keith' ? (
        <CallKeithPopUp
          hidePopup={() => {
            setShowBackdrop(false)
            setBanners(null)
            dispatch(unhideChat())
          }}
        />
      ) : null}
      {prefs.liveChat && popupForms.chatState !== CHAT_STATE_LOADING && (
        <LiveChatWidget
          license={process.env.GATSBY_LIVECHAT_KEY}
          chatBetweenGroups={false}
          visibility={chatVisibility}
          onVisibilityChanged={handleVisibilityChanged}
          onFormSubmitted={onLiveChatFormSubmitted} 
          sessionVariables={
            popupForms.offerSent
              ? {
                sku: popupForms.product.sku,
                name: popupForms.product.title,
                price: popupForms.product.price,
                image: popupForms.product.image.url,
                make_an_offer_amount: popupForms.offerPrice,
                full_name: popupForms.fullName,
                e_mail_address: popupForms.email,
                mobile_phone: popupForms.phone,
                message: popupForms.message,
              }
              : {}
          }
          group={group.toString()}
        />
      )}
    </div>
  )
}
PopUpsAndChat.propTypes = {
  navbarOpen: PropTypes.bool,
}

export default PopUpsAndChat
